import { useEffect, useRef } from 'react';

export function useAutoRefresh(
  callback: () => void | Promise<void>,
  options?: { intervalMs?: number; enabled?: boolean }
) {
  const { intervalMs = 30000, enabled = true } = options || {};
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) return;

    let intervalId: number | null = null;

    const tick = () => {
      if (document.hidden) return;
      void callbackRef.current();
    };

    intervalId = window.setInterval(tick, intervalMs);

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        void callbackRef.current();
      }
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleVisibilityChange);

    return () => {
      if (intervalId != null) window.clearInterval(intervalId);
      window.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleVisibilityChange);
    };
  }, [enabled, intervalMs]);
}
